import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "sonner";
import { CATEGORY_LABELS } from "@/lib/shoppingConstants";

/**
 * Generate a PDF of the current shopping list and trigger download.
 *
 * @param {object} params
 * @param {object} params.shoppingList   The active shopping list { items[], store?, receipts? }
 * @param {string} params.weekStart      ISO week-start date (used in filename)
 * @param {string} params.weekRangeText  Pretty week range (e.g. "uke 23 · 1.6 – 7.6")
 * @param {string} params.stockLabelTitle "Om bord" / "Hjemme" depending on edition
 * @param {number} params.totalSpent     Sum of all receipt amounts (printed at bottom)
 */
export function exportShoppingListPdf({ shoppingList, weekStart, weekRangeText, stockLabelTitle, totalSpent }) {
  if (!shoppingList?.items?.length) {
    toast.error("Handlelisten er tom");
    return;
  }
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text("Handleliste", 14, 22);
  doc.setFontSize(10);
  doc.text(`Uke: ${weekRangeText}`, 14, 30);
  if (shoppingList.store) doc.text(`Butikk: ${shoppingList.store}`, 14, 36);

  const rows = shoppingList.items.map((item) => [
    item.status === "kjopt" ? "Kjøpt" : item.status === "har_om_bord" ? stockLabelTitle : "",
    item.name,
    `${item.amount} ${item.unit}`.trim(),
    CATEGORY_LABELS[item.category] || item.category,
  ]);

  // Use autoTable function directly (jspdf-autotable v5.0+ API)
  autoTable(doc, {
    startY: shoppingList.store ? 42 : 36,
    head: [["Status", "Vare", "Mengde", "Kategori"]],
    body: rows,
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { fillColor: [6, 95, 70] },
  });

  if (totalSpent > 0) {
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(11);
    doc.text(`Totalt handlet: ${totalSpent.toFixed(2)} kr`, 14, finalY);
  }

  doc.save(`handleliste-${weekStart}.pdf`);
  toast.success("PDF lastet ned!");
}
